export class EnderecoCep {

    cep: string;
    siglaUf: string;
    municipio: Municipio;
    codigoIbgeMunicipio: string;
    tipoLogradouro: string;
    logradouro: string;
    bairro: Bairro;
    idBairro: number;
    idMunicipioIbge?: string;

    constructor(data) {
        this.cep = data.cep;
        this.siglaUf = data.uf;
        this.municipio = data.municipio;
        this.codigoIbgeMunicipio = data.ibgeMunicipio;
        this.tipoLogradouro = data.tipoLogradouro;
        this.logradouro = data.logradouro;
        this.bairro = data.bairro;
        this.idBairro = data.bairro ? data.bairro.codigo : null;
    }

}

export class Bairro {
    codigo: number;
    codigoMunicipio: string;
    nome: string;
    municipio?: Municipio;
    id: string;
}

export class Municipio {
    codigo: string;
    codigoUf: string;
    latitude: string;
    longitude: string;
    nome: string;
    siglaUf: string;
    id?: string;
    uf?: UfDto;
}

export class UfDto {
    id: string;
    nome: string;
    sigla: string;
}